export enum GeoType {
  POINT = 'Point',
  POLYGON = 'Polygon',
  MULTI_POLYGON = 'MultiPolygon'
}
